// extracted by mini-css-extract-plugin
export default {"hideTooltip":"b_-z","fadeIn":"c_-z","delay":"d_-z","recommendedSizeTooltip":"e_-z"};